module.exports = "/dist/assets/images/favicon-16x16.png";